import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { AuthenticatedApp } from "./AuthenticatedApp";
import { useAuthContext } from "./providers/AuthProvider";
import { ContentProvider } from "./providers/ContentProvider";
import PublicApp from "./PublicApp";

export const App = () => {
  const location = useLocation();
  const hostname = window.location.hostname;
  const isPortal = /[-.]portal\./.test(hostname) || hostname.startsWith("portal.");
  const isCallback =
    location.pathname.startsWith("/auth/signin-callback") ||
    location.pathname.startsWith("/auth/signout-callback");
  const { isAuthenticated, isLoading } = useAuthContext();
  const auth = useAuth();
  const [hasTriedAuth, setHasTriedAuth] = useState(false);

  useEffect(() => {
    if (
      isPortal &&
      !isCallback &&
      !isLoading &&
      !isAuthenticated &&
      !hasTriedAuth &&
      !auth.isLoading &&
      !auth.activeNavigator
    ) {
      setHasTriedAuth(true);
      auth.signinRedirect();
    }
  }, [isPortal, isCallback, isLoading, isAuthenticated, hasTriedAuth, auth]);

  if (isCallback) {
    return <PublicApp />;
  }

  if (isLoading) {
    return null;
  }

  if (isPortal && !isAuthenticated) {
    if (!hasTriedAuth && !auth.activeNavigator) {
      return null;
    }
    return null;
  }

  if (isAuthenticated) {
    return (
      <ContentProvider>
        <AuthenticatedApp />
      </ContentProvider>
    );
  }

  return <PublicApp />;
};
